<script>
    import ExcerptModal from './ExcerptModal.svelte';
    import { util } from '../utils/excerptsUtil.js';
    import * as commonUtil from '../utils/commonUtil.js';
    import { dbUtil } from '../utils/dbUtil.js';
    import ShareHelpModal from '../utils/ShareHelpModal.svelte';
    import WelcomeCard from '../WelcomeCard.svelte';
    import ExcerptsMenu from './ExcerptsMenu.svelte';

    let excerptsPromise = util.getExcerpts();
    let tagDetails = dbUtil.getTagsById();
    let excerptsData = Promise.all([excerptsPromise, tagDetails]);
    
    async function loadData() {
        excerptsPromise = util.getExcerpts(true);
        tagDetails = dbUtil.getTagsById(true);
        excerptsData = Promise.all([excerptsPromise, tagDetails]);
    }

    let showAddEntryModal = false;
    export let inputText = null;
    export let inputSource = null;
    
    if (inputText != null && inputText != '') {
        showAddEntryModal = true;
    }

    export let inputLink = null;
    function closeExcerptModal() {
        showAddEntryModal = false;
        //If popup is triggered externally, it needs to auto-close after saving
        if (inputLink != null && inputLink != '') {
            window.close();
        }
    }

    let isHovered = false;
    let hoveredId = '';
    function setActive(event) {
        let id = event.target.id;
        isHovered = true;
        hoveredId = id;
    }
    function setInactive(event) {
        let id = event.target.id;
        isHovered = false;
        hoveredId = '';
    }

    function handleMessage(event) {
        console.log('Received event ' + JSON.stringify(event.detail));
		let eventType = event.detail.eventType;
        if (eventType === 'changed') {
            loadData();
        }
	}
</script>

<div id="excerpts" class="font-thasadith-regular">
    {#await excerptsData}
        <span class="info-text">...loading</span>
    {:then excerptsAndTagsData}
        {#each excerptsAndTagsData[0] as data}
            <div class="excerpt" id="{data.id}" on:mouseenter={(event) => {setActive(event)}} on:mouseleave={(event) => {setInactive(event)}}>
                <div class="excerpt__top-bar" class:excerpt__top-bar--visible="{isHovered && hoveredId == data.id}">
                    <ExcerptsMenu excerpt={data} on:message={handleMessage}/>
                </div>
                <div class="excerpt__content">
                    {data.excerpt}
                </div>
                {#if data.source != null && data.source != ''}
                    <div class="excerpt__source font-thasadith-italic">
                        {data.source}
                    </div>
                {/if}
                <div class="excerpt__description">
                    {data.description}
                </div>
                <div class="excerpt__tags">
                    {#if data.tags != null && commonUtil.areAllTagsPresent(data.tags, Object.keys(excerptsAndTagsData[1]), 'excerpts')}
                        {#each data.tags as tagID}
                            <span class="tag" style="background-color: {(excerptsAndTagsData[1])[tagID].color}; 
                                color: {commonUtil.getContrastingColor((excerptsAndTagsData[1])[tagID].color)}">
                                {(excerptsAndTagsData[1])[tagID].name}
                            </span>  
                        {/each}
                    {/if}
                </div>
            </div>
        {/each}
        {#if excerptsAndTagsData[0].length == 0}
            <div id="welcome-card">
                <WelcomeCard view="excerpt"/>
            </div>
        {/if}
    {:catch error}
        Oops, there was an error! :(
        {error}
    {/await}

    <button id="add-button" on:click={() => {showAddEntryModal = true}}>&nbsp;+&nbsp;</button>
    
    {#if showAddEntryModal}
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <div class="modal-background" on:click={closeExcerptModal}></div>
        <div class="modals">
            <div class="modal">
                <ExcerptModal inputText={inputText} inputSource={inputSource} on:saved="{loadData}" on:close={closeExcerptModal}/>
            </div>

            {#if inputText != null && inputText != ''}
                <div class="modal share-help">
                    <ShareHelpModal msgContent={commonUtil.getAllQueryParams()}/>
                </div>
            {/if}
        </div>
    {/if}
</div>


<style>
    .modal-background {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: rgba(0,0,0,0.3);
        color: black;
	}
    .modals {
        display: flex;
        flex-direction: column;
		position: absolute;
		left: 50%;
		top: 50%;
		width: calc(100vw - 4em);
		max-width: 32em;
		max-height: calc(100vh - 4em);
		overflow: auto;
		transform: translate(-50%,-50%);
	}
    .modal {
        padding: 0em 1em 1em 1em;
		border-radius: 0.2em;
        background: white;
        color: black;
        margin: 0.5em;
    }
    .modal.share-help {
        padding: 1em;
    }
    #excerpts {
        color: white;
        columns: 20em;
        column-gap: 1em;
    }
    .excerpt { /* Masonry bricks or child elements */
        display: inline-block;
        margin: 0 0 1em;
        padding: 1em;
        width: 100%;
        border: 5px solid rgb(73, 73, 73);
        white-space: pre-line; 
        position: relative;
    }
    .excerpt__top-bar {
        position: absolute;
        top:0; 
        right:0;
        height: 2em;
        padding: 0.2em;
        display: flex;
        column-gap: 0.7em;
        align-items: center;
        background-color: rgba(0, 0, 0, 0.3);
        border-bottom-left-radius: 5px;
        opacity: 0;
        margin: 0.5em;
    }
    .excerpt__top-bar--visible {
        opacity: 1;
    }
    .excerpt__content {
        word-break: break-word;
    }
    .excerpt__source {
        word-break: break-word;
        margin: 0.5em 0em;
        padding: 0.5em;
        width: fit-content;
        background-color: rgba(255, 255, 255, 0.059);
    }
    .excerpt__description {
        word-break: break-word;
        font-weight: bold;
    }
    .excerpt__source {
        font-size: 0.8em;
        font-style: italic;
    }
    .excerpt__tags {
        font-size: 0.8em;
        margin-top: 1em;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        gap: 10px;
        bottom: 0px;
    }
    .tag {
        padding: 0.3em 0.5em;
        border-radius: 5px;
    }

    #add-button {
        background-color: rgb(54, 54, 54);
        padding: 0.5em;
        position: absolute;
        bottom: 2em;
        right: 9%;
        border: 5px solid rgb(78, 78, 78);
        border-radius: 10em;
        font-weight: 900;
        font-size: 2em;
    }
    #new-entry__error {
        color: red;
        font-style: italic;
    }
    #new-entry__success {
        color: green;
        font-style: italic;
    }
    #welcome-card {
        display: inline-block;
    }
</style>